const OPEN_APP_DRAWER = 'ui/drawer/OPEN_APP_DRAWER';
const CLOSE_APP_DRAWER = 'ui/drawer/CLOSE_APP_DRAWER';

export default {
  OPEN_APP_DRAWER,
  CLOSE_APP_DRAWER,
};
